export const TIME_UNIT = 'TECH_TIME_UNIT';
export const QUANTITY_UNIT = 'TECH_QUANTITY_UNIT';
export const TECH_EPI = 'TECH_EPI';
export const INVENTORY_TO_PLAN = 'INVENTORY_TO_PLAN';
export const INFESTATION_LEVEL = 'TECH_INFESTATION_LEVEL';
export const INFRA_TYPE = 'INFRASTRUCTURE_TYPE';
export const CONTRACT_TYPE = 'TECH_CONTRACT_TYPE';
export const TARGET_RAT = 'TARGET_RAT';
export const TARGET_INSECT = 'TARGET_INSECT';
export const TREATMENT_INSECT = 'TREATMENT_INSECT';
export const TARGET_OTHER = 'TARGET_OTHER_PESTS';
export const TREATMENT_OTHER = 'TREATMENT_OTHER_PESTS';
export const TASK_ONE_SIMPLE_LIST_ONE = 'TASK_ONE_SIMPLE_LIST_ONE';
export const TASK_ONE_SIMPLE_LIST_TWO = 'TASK_ONE_SIMPLE_LIST_TWO';
export const TASK_ONE_COMPLEX_LIST = 'TASK_ONE_COMPLEX_LIST';
export const TASK_TWO_SIMPLE_LIST_ONE = 'TASK_TWO_SIMPLE_LIST_ONE';
export const TASK_TWO_SIMPLE_LIST_TWO = 'TASK_TWO_SIMPLE_LIST_TWO';
export const TASK_TWO_COMPLEX_LIST = 'TASK_TWO_COMPLEX_LIST';
export const PLACE = 'PLACE';
export const PLACE_ACCESSIBILITY = 'PLACE_ACCESSIBILITY';
export const AAST_HOUSING_TYPE = 'AAST_HOUSING_TYPE';
export const AAST_ANNEXES = 'AAST_ANNEXES';
export const ASST_SOIL_TYPE = 'ASST_SOIL_TYPE';



// WEBPACK FOOTER //
// ./src/modules/saas/references/constants/index.js